export class OrderToBoxDto {
    orderId: string;
    lang: string;
}
